<ion-header
  class="ion-no-border"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      slot="end"
    >
      <ion-button
        id="close-modal-btn"
        data-cy="close-calendar-modal-button"
        (click)="closeModal()"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label data-cy="change-date-label">
      {{ calendarTitle }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  class="calendar_content"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
  scroll-y="true"
>
  <mat-card class="calendar-card">
    <div class="selected-date-banner">
      <ion-icon name="alert-circle-outline" class="alertIcon"></ion-icon>
      <div data-cy="current-date-selected-label">
        {{ 'i18n.common.currentlySelected' | translate }}
        <span data-cy="current-date-selected-text">
          {{ formattedNewSelectedDate?.toDate() | date: 'longDate' : 'GMT' }}
        </span>
      </div>
    </div>
    <mat-calendar
      data-cy="select-date-calendar"
      (selectedChange)="onSelectedChange($event)"
      [selected]="formattedNewSelectedDate"
      [startAt]="currentSelectedDate"
      [dateFilter]="dateFilter"
      [dateClass]="dateClass"
      [minDate]="minDate"
      matDatepicker
      #calender
    ></mat-calendar>
  </mat-card>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="
    (platformService?.isTouchExperience$ | async) === false
  "
>
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="update-date-btn"
        [ngClass]="
          platformService?.platformType !==
          platformService?.platformEnum?.mobile
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        "
        data-cy="submit-date-button"
        (click)="submitDateModal()"
        translate
      >
        {{ 'i18n.common.update' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
